// frontend/klaes-app/src/components/FilmFavs/components/UserRatingsPopup.jsx
import { FiX } from 'react-icons/fi';
import { BatteryIndicator } from './BatteryIndicator';
import styles from '../FilmFavs.module.css';

export const UserRatingsPopup = ({ ratings, users, onClose }) => {
  return (
    <div className={styles.userRatingsPopup}>
      <div className={styles.userRatingsHeader}>
        <span>Alle Bewertungen</span>
        <FiX onClick={onClose} />
      </div>
      <div className={styles.userRatingsList}>
        {Object.entries(ratings).map(([userName, rating]) => {
          const user = users[userName] || { avatar_emoji: '👤', tagname: userName };
          return (
            <div key={userName} className={styles.userRatingItem}>
              <div className={styles.userInfo}>
                <span className={styles.userAvatar}>{user.avatar_emoji || '👤'}</span>
                <span className={styles.userName}>{user.tagname || userName}</span>
              </div>
              <BatteryIndicator rating={rating} />
            </div>
          );
        })}
      </div>
    </div>
  );
};